import { styled } from '@mui/material/styles';
import Typography, { type TypographyProps } from '@mui/material/Typography';

const StyledComponent = styled(Typography)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  display: 'inline-block',
});

export const OverflowEllipsis = (props: TypographyProps) => (
  <StyledComponent variant="inherit" {...props} />
);

export default OverflowEllipsis;
